const Testimonials = (testimonials) => {
    const view = testimonials.posts
      .map((testimonial) => {
        const clientType = !testimonial['testimonial-client-type'] ? '' : `, ${testimonial['testimonial-client-type']}`
        return `
          <div class="testimonials-item">
            <div class="icon-holder">
              <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="64" height="64" fill="#76013C"/>
                <path d="M16.1769 43.3514C13.9795 41.0175 12.7998 38.3999 12.7998 34.1567C12.7998 26.69 18.0414 19.9978 25.6638 16.689L27.5689 19.6287C20.4542 23.4772 19.0633 28.4714 18.5086 31.6202C19.6542 31.0271 21.1539 30.8202 22.6238 30.9567C26.4723 31.313 29.5059 34.4724 29.5059 38.3999C29.5059 40.3802 28.7193 42.2794 27.319 43.6796C25.9187 45.0799 24.0196 45.8666 22.0393 45.8666C20.9441 45.857 19.8619 45.6297 18.8554 45.1979C17.849 44.7661 16.9384 44.1384 16.1769 43.3514ZM37.5102 43.3514C35.3129 41.0175 34.1331 38.3999 34.1331 34.1567C34.1331 26.69 39.3747 19.9978 46.9971 16.689L48.9022 19.6287C41.7875 23.4772 40.3966 28.4714 39.8419 31.6202C40.9875 31.0271 42.4873 30.8202 43.9571 30.9567C47.8057 31.313 50.8393 34.4724 50.8393 38.3999C50.8393 40.3802 50.0526 42.2794 48.6523 43.6796C47.2521 45.0799 45.3529 45.8666 43.3726 45.8666C42.2775 45.857 41.1952 45.6297 40.1887 45.1979C39.1823 44.7661 38.2718 44.1384 37.5102 43.3514Z" fill="#FFC34D"/>
              </svg> 
            </div>

            <div class="testimonials-content">
              ${testimonial['testimonial-content']}
            </div>

            <div class="author">— ${testimonial['testimonial-client']}${clientType}</div>

          </div>
          `;
      })
      .join('');
    return view;
  };
  
  export default Testimonials;